import { Box, Typography, useTheme } from "@mui/material";
import React from "react";
import ReactApexChart from "react-apexcharts";
import { incrementIcon } from "../../../assets";
import { tokens } from "../../../theme";
import TimeSelect from "./TimeSelect";

export const SplineChart = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const options = {
    chart: {
      height: 350,
      type: "area",
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "smooth",
    },
    xaxis: {
      //   categories: [
      //     "2018-09-19T00:00:00.000Z",
      //     "2018-09-19T01:30:00.000Z",
      //     "2018-09-19T02:30:00.000Z",
      //     "2018-09-19T03:30:00.000Z",
      //     "2018-09-19T04:30:00.000Z",
      //     "2018-09-19T05:30:00.000Z",
      //     "2018-09-19T06:30:00.000Z",
      //     ],
      type: "category",
      categories: [
        "Jan 15",
        "Feb 15",
        "Mar 15",
        "Apr 15",
        "May 15",
        "Jun 15",
        "Jul 15",
        "Aug 15",
        "Sep 15",
        "Oct 15",
        "Nov 15",
        "Dec 15",
      ],
    },
    tooltip: {
      x: {
        format: "dd/MM/yy HH:mm",
      },
    },
  };

  const series = [
    {
      name: "series1",
      data: [0, 5, 10, 20, 31, 40, 28, 51, 42, 60, 78, 109],
      color: "#6A27EA",
    },
  ];

  return (
    <Box
      width="100%"
      sx={{
        marginTop: "30px",
        "& .apexcharts-toolbar": {
          display: "none",
        },
      }}
    >
      <Typography variant="h6" fontWeight={500} color={colors.black[400]}>
        Rental History
      </Typography>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "220px",
          }}
        >
          <img src={incrementIcon} alt="increment" />
          <Typography variant="fs14" fontWeight={400} color={colors.black[400]}>
            All Time Avg. Price
          </Typography>
          <Typography variant="fs14" fontWeight={400} color={colors.black[300]}>
            $3500.00
          </Typography>
        </Box>
        <TimeSelect />
      </Box>
      <ReactApexChart
        options={options}
        series={series}
        type="area"
        height="350"
      />
    </Box>
  );
};
